import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import cdu from "../../assets/images/institute-logos/christ-university.jpg";
// import tirupati from "../../assets/images/client-logo/tirupati.jpeg";
import BU from '../../assets/images/institute-logos/Burdwan-University.png'
import iitindore from '../../assets/images/institute-logos/IIT-Indore.jpg'
import kristu from '../../assets/images/institute-logos/Kristu-Jayanti-College.png'
import mangalam from '../../assets/images/institute-logos/Mangalam-College.png'
import rajagiri from '../../assets/images/institute-logos/Rajagiri-School-Engineering.jpg'
import rit from '../../assets/images/client-logo/rit.png'
import svnit from "../../assets/images/client-logo/svnit.png";
import manukaula from '../../assets/images/institute-logos/Sri-Manakula-Vinayagar.png'


function AcademicCollaboration() {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="mb-20">
      <div className="container">
        <h2 className="text-center py-20">Academic Collaborations</h2>
        <Slider {...settings}>
          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon">
                <img className="" src={cdu} alt="Christ Logo"  />
              </div>
            </div>
          </div>

          {/* <div className="slide-item px-1 ">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon">
                <img className="" src={tirupati} alt="Tirupati Logo" height="85px" width="150px" />
              </div>
            </div>
          </div> */}

          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div  >
                <img  src={BU} alt="BU Logo"  height="130px" width="140px"/>
              </div>
            </div>
          </div>

          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon">
                <img  src={iitindore} alt="IIT Indore Logo"  height="170px" width="220px" className="mt-2" />
              </div>
            </div>
          </div>

          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon">
                <img className='imp-img3'src={kristu} alt="Kristu Jayanti College Logo" />
              </div>
            </div>
          </div>

          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon">
                <img className='imp-img3' src={mangalam} alt="Mangalam College Logo" />
              </div>
            </div>
          </div>

          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className='imp-img3'>
                <img className="" src={rajagiri} alt="Rajagiri College Logo" />
              </div>
            </div>
          </div>

          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon">
                <img className="" src={rit} alt="Ramaiah College Logo" />
              </div>
            </div>
          </div>
          
          
          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon">
                <img className="academic-logo" src={svnit} alt="SVNIT Logo" />
              </div>
            </div>
          </div>

          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon">
                <img className="academic-logo" src={manukaula} alt="Sri Manukula Logo" />
              </div>
            </div>
          </div>

        </Slider>
      </div>


    </section>
  );
}

export default AcademicCollaboration;
